// import { useUserStore } from "@/stores";
/**
 * removeUnusedStorage() is a function used to remove unused or unnecessary data from local storage.
 * @param routeName
 * @returns {void}
 */
export const removeUnusedStorage = (routeName: string) => {};

const mapStore = {
  // userStore: useUserStore,
};
/**
 * As local storage is not reactive this function handle it when local storage key removed its reset the stores as well
 *not satisfied with solution will pick this up later on
 * @param key -store key
 */
const resetLocalStorage = (key) => {
  mapStore[key]().$reset();
};

export const deleteFromLocalStorage = (key) => {
  if (localStorage.getItem(key)) {
    localStorage.removeItem(key);
    if (Object.keys(mapStore).includes(key)) resetLocalStorage(key);
  }
};

/**
 * Retrieves an item from local storage.
 * @param {string} key - The key to retrieve.
 * @returns {string|null} - The value associated with the key, or null if it doesn't exist.
 */
export const localStorageGetItem = (key: string): string | null => {
  return localStorage.getItem(key);
};

/**
 * Saves an item to local storage.
 * @param {string} key - The key to set.
 * @param {string} value - The value to associate with the key.
 */
export const localStorageSetItem = (key: string, value: string) => {
  return localStorage.setItem(key, value);
};

/**
 * Loads selected column IDs from localStorage for a specific page/component.
 * @param {string} storageKey - The unique key to identify the column selection.
 * @param {number[]} defaultColumns - Default column IDs to return if no saved data exists.
 * @returns {number[]} - Array of selected column IDs.
 */
export const loadSelectedColumns = (
  storageKey: string,
  defaultColumns: number[]
): number[] => {
  try {
    const saved = localStorageGetItem(storageKey);
    if (saved) {
      const parsed = JSON.parse(saved);
      // Validate that it's an array of numbers
      if (
        Array.isArray(parsed) &&
        parsed.every((id) => typeof id === "number")
      ) {
        return parsed;
      }
    }
  } catch (error) {
    console.error("Error loading selected columns from localStorage:", error);
  }
  // Return default columns if no valid data exists
  return defaultColumns;
};

/**
 * Saves selected column IDs to localStorage for a specific page/component.
 * @param {string} storageKey - The unique key to identify the column selection.
 * @param {number[]} columnIds - Array of selected column IDs to save.
 */
export const saveSelectedColumns = (
  storageKey: string,
  columnIds: number[]
): void => {
  try {
    localStorageSetItem(storageKey, JSON.stringify(columnIds));
  } catch (error) {
    console.error("Error saving selected columns to localStorage:", error);
  }
};
